module.exports = __webpack_public_path__ + "static/front/img/banner-3.85a4ea4a.jpg";